export const emailListInputStyles = {
	group: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	}
};
